module.exports = __webpack_public_path__ + "images/js11x5.40e7.png";